module.exports = __webpack_public_path__ + "static/media/sciendomus.png";